import { z } from 'zod';
export const discordIntegrationTypeSchema = z.enum([
    'newQuest',
    'newClaim',
    'leaderboardSprintEnd',
    'dailySummary',
    'support',
]);
